export default (() => {
  const body = document.querySelector("body");

  const fixedPoint = 10;
  let ticking = false;

  const scrollFunction = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (window.scrollY >= fixedPoint) {
          body.classList.add("scrolled");
        } else {
          body.classList.remove("scrolled");
        }
        ticking = false;
      });

      ticking = true;
    }
  };
  // For every scroll event, if you aren't already waiting,
  // wait until you're goong to redraw next then update the classes
  scrollFunction();
  window.addEventListener("scroll", scrollFunction);
})();
